import { Link, usePage } from '@inertiajs/react'
import { Bell } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { SharedProps } from '@/types'

export default function NotificationBell() {
  const { unread_notification_count: count } = usePage<SharedProps>().props
  const hasUnread = count > 0
  const label = hasUnread ? `Notifications (${count} unread)` : 'Notifications'

  return (
    <Button
      asChild
      variant="ghost"
      size="icon"
      className="relative h-8 w-8 rounded-full"
      aria-label={label}
    >
      <Link href="/notifications">
        <Bell className="size-5" />
        {hasUnread && (
          <span
            className="absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground"
            aria-hidden
          >
            {count > 9 ? '9+' : count}
          </span>
        )}
      </Link>
    </Button>
  )
}
